import { format, parseISO, parse, addMinutes, isBefore, isAfter, startOfDay } from "date-fns";
import { withPrefix } from "gatsby";

export const getEventsForDate = async (date, locale) => {
	const collectionId = "all-events";
	const dateId = parseInt(format(date, "yyyyMMdd"));
	const fileDate = format(date, "yyyy-MM");
	const requestedWeekday = date instanceof Date ? date.getDay() : -1;
	const path = withPrefix(`/paginated-data/${collectionId}/${locale}/events-${fileDate}.json`);
	const hasWindow = typeof (window) !== 'undefined' && window;
	let response, json;
	if (hasWindow && window["eventsResponse" + locale + fileDate]) {
		json = window["eventsResponse" + locale + fileDate];
	} else {
		response = await fetch(path);
		if (response?.status >= 200 && response?.status <= 299) {
			json = await response.json();
			if (json) {
				window["eventsResponse" + locale + fileDate] = json;
			}
		}
	}
	if (json) {
		const jsonEvents = [];
		json?.events?.map((event) => {
			if (!(event?.node?.startDate) || !(Array.isArray(event?.node?.tapahtuma)) || event.node.tapahtuma.length === 0) {
				return false;
			}

			event.node.tapahtuma.map((eventObject) => {
				if (!(Array.isArray(eventObject.eventDates)) || !(eventObject.eventDates.length)) {
					return false;
				}
				const eventStartDate = parseISO(eventObject.eventDates[0].startDate);
				const eventStart = parseInt(format(eventStartDate, "yyyyMMdd"));
				const eventEnd = eventObject.eventDates[0].endDate ? parseInt(format(parseISO(eventObject.eventDates[0].endDate), "yyyyMMdd")) : eventStart;

				const eventOpeningHours = eventObject.openingHours || {};
				if (requestedWeekday !== -1 && Object.keys(eventOpeningHours).length > 0) {
					switch (requestedWeekday) {
						case 0:
							if (!(eventOpeningHours.sundayFrom || "")) {
								return false;
							}
							break;
						case 1:
							if (!(eventOpeningHours.mondayFrom || "")) {
								return false;
							}
							break;
						case 2:
							if (!(eventOpeningHours.tuesdayFrom || "")) {
								return false;
							}
							break;
						case 3:
							if (!(eventOpeningHours.wednesdayFrom || "")) {
								return false;
							}
							break;
						case 4:
							if (!(eventOpeningHours.thursdayFrom || "")) {
								return false;
							}
							break;
						case 5:
							if (!(eventOpeningHours.fridayFrom || "")) {
								return false;
							}
							break;
						case 6:
							if (!(eventOpeningHours.saturdayFrom || "")) {
								return false;
							}
							break;
					}
				}

				if (eventStart === dateId || eventEnd === dateId || (eventStart < dateId && eventEnd > dateId)) {
					eventObject.nextDate = eventStartDate;
					jsonEvents.push(eventObject);
				}
			});
		});
		return jsonEvents;
	} else {
		return [];
	}
};

export const actuallyRemoveDuplicatedEvents = (events) => {
	let ret = {};

	events.map((event) => {
		ret[event.id + "-" + (event.startDateSortParsed || event.startTime || "")] = event;
	});

	return Object.values(ret);
};

export const removeSameDayDuplicates = (events) => {
	let eventIdDates = {};
	return events.filter((event) => {
		let eventEnd, eventStart;
		if ((event.startDateSortParsed || "").length > 0) {
			eventStart = parseISO(event.startDateSortParsed);
			eventEnd = (event.endDateSortParsed || "").length > 0 ? parseISO(event.endDateSortParsed) : eventStart;
		} else {
			if (!(Array.isArray(event.eventDates)) || event.eventDates.length === 0) {
				eventStart = parseISO(event.startDateSortParsed || event.startTime);
				eventEnd = parseISO(event.endDateSortParsed || event.endTime);
			} else {
				eventStart = parseISO(event.eventDates[0].startDate);
				eventEnd = event.eventDates[0].endDate ? parseISO(event.eventDates[0].endDate) : parseISO(event.endDateSortParsed || event.endTime);
				eventEnd.setSeconds(59);
			}
		}
		if (!eventStart) {
			return true;
		}
		eventStart = format(eventStart, "yyyyMMdd");
		eventEnd = eventEnd ? format(eventEnd, "yyyyMMdd") : eventStart;
		if (eventStart === eventEnd) {
			if (eventStart in (eventIdDates[event.id] || {})) {
				return false;
			}
			eventIdDates[event.id] = {};
			eventIdDates[event.id][eventStart] = true;
		}
		return true;
	});
};

export const removeDuplicatedEvents = (event, i, arr) => {
	// Non recurring events are never duplicated.
	if (!(event.isEventRepeating)) {
		return true;
	}

	return arr.findIndex((otherEvent) => otherEvent.id === event.id) === i;
};

export const getCategoryIds = (categories) => categories.map((category) => category.contentful_id);

export const getCategoryFilters = (selectedMainCategory, selectedSubCategories) => {
	if (selectedSubCategories.length > 0) {
		return getCategoryIds(selectedSubCategories);
	}

	if (!selectedMainCategory) {
		return [];
	}

	if (!selectedMainCategory?.subcategories) {
		return getCategoryIds([selectedMainCategory]);
	}

	return getCategoryIds([selectedMainCategory, ...selectedMainCategory.subcategories]);
};

export const filterEventsByCategories = (events, categoryIds) => {
	if (categoryIds?.length === 0) {
		return events;
	}

	return events.filter((event) => {
		if (!event.categories) return false;

		return event.categories
			.map((category) => category.contentful_id)
			.some((id) => categoryIds.includes(id));
	});
};

export const filterEventsBySenseCategories = (events, senseCategoryIds) => {
	if (senseCategoryIds?.length === 0) {
		return events;
	}

	return events.filter((event) => {
		if (!event.senseCategories) return false;

		return event.senseCategories
			.map((senseCategory) => senseCategory.id)
			.some((id) => senseCategoryIds.includes(id));
	});
};

export const isOngoingEvent = (event, now, timeLimit = 30) => {
	let eventStart, eventEnd;
	if (!(Array.isArray(event.eventDates)) || event.eventDates.length === 0) {
		eventStart = parseISO(event.startDateSortParsed || event.startTime);
		eventEnd = parseISO(event.endDateSortParsed || event.endTime);
	} else {
		eventStart = parseISO(event.eventDates[0].startDate);
		eventEnd = event.eventDates[0].endDate ? parseISO(event.eventDates[0].endDate) : parseISO(event.endDateSortParsed || event.endTime);
		eventEnd.setSeconds(59);
		if (event.startOpeningHours) {
			const [openingHour, openingMinutes] = event.startOpeningHours[now.getDay()].split(":");
			eventStart.setHours(openingHour);
			eventStart.setMinutes(openingMinutes);
			eventStart.setSeconds(0);
		}
		if (event.endOpeningHours) {
			const [closingHour, closingMinutes] = event.endOpeningHours[now.getDay()].split(":");
			eventEnd.setHours(closingHour);
			eventEnd.setMinutes(closingMinutes);
		} else {
			// these dates do not have time in UI, assume end of day
			eventEnd.setHours(23);
			eventEnd.setMinutes(59);
		}
	}

	// if the event starts before current day or ends after current day, check if event is actually ongoing today by opening
	// times
	const formattedNow = format(now, "yyyyMMdd");
	if (format(eventStart, "yyyyMMdd") < formattedNow) {
		eventStart.setFullYear(now.getFullYear(), now.getMonth(), now.getDate());
	}
	if (format(eventEnd, "yyyyMMdd") > formattedNow) {
		eventEnd.setFullYear(now.getFullYear(), now.getMonth(), now.getDate());
	}
	return eventStart <= addMinutes(now, timeLimit) && eventEnd > now;
};

const getRecurringEventEndTimeForDate = (event, date) => {
	return parse(event.endOpeningHours[date.getDay()], "HH:mm", date);
}

export const isPastEvent = (event, now) => {
	// For recurring events, endDateSortParsed is the start of the ending day (00:00 Finnish time).
	// For non-recurring events, endDateSortParsed is the actual ending time.
	const endDate = parseISO(event?.endDateSortParsed);
	const compareToDate = event.isEventRepeating ? startOfDay(now) : now;

	if (isBefore(endDate, compareToDate)) {
		return true;
	}

	if (isAfter(endDate, compareToDate)) {
		return false;
	}

	// Ends today => Compare to the actual end time on current date.
	const currentDateEndTime = event.isEventRepeating ? getRecurringEventEndTimeForDate(event, now) : endDate;

	return isBefore(currentDateEndTime, now);
};

export const removeOngoingEvents = (events, ongoingEvents) => {
	return events.filter(
		(event) => !ongoingEvents.some((ongoingEvent) => ongoingEvent.id === event.id && ongoingEvent.startDateSortParsed === event.startDateSortParsed),
	);
};

export const removePastEvents = (events) => {
	const now = new Date();
	return actuallyRemoveDuplicatedEvents(events.filter((event) => !isPastEvent(event, now)));
}

export const loadEventsForDates = async (dates, locale) => {
	try {
		const promises = await dates.map((date) => getEventsForDate(date, locale));
		const responses = await Promise.allSettled(promises);
		const events = responses
			.filter((promise) => promise.status === "fulfilled" && promise.value?.length > 0)
			.map((promise) => promise.value)
			.flat();

		const uniqueEvents = actuallyRemoveDuplicatedEvents(events);

		return {items: uniqueEvents, nextPageId: 1, isLastPage: false};
	} catch (e) {
		return {items: [], nextPageId: 1, isLastPage: true};
	}
};

export const loadOngoingEvents = async (locale, timeLimit) => {
	const now = new Date();
	const result = await loadEventsForDates([now], locale);

	const ongoingEvents = result.items.filter((event) => isOngoingEvent(event, now, timeLimit));

	return ongoingEvents;
};

// Event page helpers

export const getPostValue = (locale, value) => {
	return value?.[locale] || value?.[locale] === "" ? value?.[locale] : value;
};

export const isNotEmptyValue = (locale, values, isPreview) => {
	if (isPreview) {
		const isEmptyArray = values?.map((object) => {
			return Object.values(object).some((x) => x?.[locale] !== "" && x?.[locale] !== undefined);
		});
		const isNotEmpty = isEmptyArray?.includes(true);
		return isNotEmpty;
	}
	return values?.length > 0;
};

export const getLinkValue = (value, links, originalValue) => {
	const filtered = links?.filter((obj) => Object.keys(obj)[0] === value);

	const filteredValues = filtered?.map((node) => {
		return node?.[value]?.length > 0
			? node?.[value]?.map((item) => item?.fields)
			: node?.[value]?.fields;
	});

	return filtered?.length > 0 ? filteredValues?.flat() : originalValue;
};

export const getPreviewLocations = (links, selectedLocale) => {
	if (!links) return [];

	const locationFields = links
		.filter((o) => Object.keys(o)[0] === "eventLocation")
		.map((link) => link.eventLocation)
		.flat()
		.map((node) => node.fields);

	const previewLocations = locationFields.map((field) => {
		if (field.eventLocation) {
			const location = JSON.parse(field.eventLocation);
			return location.previewString;
		} else if (field.eventLocationName) {
			return field.eventLocationName[selectedLocale];
		}
	});

	return previewLocations.filter(Boolean);
};

export const getEventDatesArrayFromLinks = (links) => {
	return (
		links?.reduce((acc, link) => {
			if (Array.isArray(link?.eventDates)) {
				return link.eventDates.map((eventDate) => {
					const eventDateObject = Object.entries(eventDate.fields).reduce((acc, [key, value]) => {
						return {
							...acc,
							[key]: value.fi,
							id: Math.random().toString().split(".")[1],
						};
					}, {});
					return eventDateObject;
				});
			}
			return acc;
		}, []) ?? []
	);
};
